<template>

    <div class="calculator-component">
        <div class="container">
            <div class="row mt-5">
                <div class="col-6">
                    <h2>Scheme Level</h2>

                    <div>
                        <label for="employer-national-insurance-rate">Employer National Insurance Rate (%)</label>
                        <input type="text" :value="employerNationalInsuranceRate" name="employer-national-insurance-rate" id="employer-national-insurance-rate">
                    </div>
                    <div>
                        <label for="employee-national-insurance-rate20">Employee National Insurance Rate 20%</label>
                        <input type="text" :value="employeeNationalInsuranceRate20" name="employee-national-insurance-rate20" id="employee-national-insurance-rate20">
                    </div>
                    <div>
                        <label for="employee-national-insurance-rate40">Employee National Insurance Rate 40%</label>
                        <input type="text" :value="employeeNationalInsuranceRate40" name="employee-national-insurance-rate40" id="employee-national-insurance-rate40">
                    </div>
                    <div>
                        <label for="employee-national-insurance-rate45">Employee National Insurance Rate 45%</label>
                        <input type="text" :value="employeeNationalInsuranceRate45" name="employee-national-insurance-rate45" id="employee-national-insurance-rate45">
                    </div>
                    <div>
                        <label for="provision-per-month">Provision Per Month</label>
                        <input type="text" :value="provisionPerMonth" name="provision-per-month" id="provision-per-month">
                    </div>
                    <div>
                        <label for="vat-recovery-percentage">VAT Recovery Percentage</label>
                        <input type="text" :value="vatRecoveryPercentage" name="vat-recovery-percentage" id="vat-recovery-percentage">
                    </div>
                    <div>
                        <label for="eti-included">ETI Included</label>
                        <input type="text" :value="etiIncluded" name="eti-included" id="eti-included">
                    </div>
                    <div>
                        <label for="eti-percentage24">ETI Percentage 24 Month</label>
                        <input type="text" :value="etiPercentage24" name="eti-percentage24" id="eti-percentage24">
                    </div>
                    <div>
                        <label for="eti-percentage36">ETI Percentage 36 Month</label>
                        <input type="text" :value="etiPercentage36" name="eti-percentage36" id="eti-percentage36">
                    </div>
                    <div>
                        <label for="eti-percentage48">ETI Percentage 48 Month</label>
                        <input type="text" :value="etiPercentage48" name="eti-percentage48" id="eti-percentage48">
                    </div>
                    <div>
                        <label for="give-nic-saving-back-to-employee">Give NIC Saving Back To Employee</label>
                        <input type="text" :value="giveNicSavingBackToEmployee" name="give-nic-saving-back-to-employee" id="give-nic-saving-back-to-employee">
                    </div>
                    <div>
                        <label for="give-nic-saving-back-to-employee">Percentage of NIC Shared With Employee</label>
                        <input type="text" :value="percentageOfNICSharedWithEmployee" name="percentage-of-NIC-shared-with-employee" id="percentage-of-NIC-shared-with-employee">
                    </div>
                    <div>
                        <label for="percentage-for-nic-saving-calculation">Percentage For NIC Saving Calculation</label>
                        <input type="text" :value="percentageForNicSavingCalculation" name="percentage-for-nic-saving-calculation" id="percentage-for-nic-saving-calculation">
                    </div>
                    <div>
                        <label for="percentage-for-employer-saving-calculation">Percentage For Employer Saving Calculation</label>
                        <input type="text" :value="percentageForEmployerSavingCalculation" name="percentage-for-employer-saving-calculation" id="percentage-for-employer-saving-calculation">
                    </div>

                    <h2 class="mt-5">Employee Level</h2>

                    <div>
                        <label for="employee-tax-rate">Employee Tax Rate</label>
                        <input type="text" :value="employeeTaxRate" name="employee-tax-rate" id="employee-tax-rate">
                    </div>
                    <div>
                        <label for="employee-nic-rate">Employee NIC Rate</label>
                        <input type="text" :value="employeeNicRate" name="employee-nic-rate" id="employee-nic-rate">
                    </div>
                    <div>
                        <label for="insurance-premium">Insurance Premium</label>
                        <input type="text" :value="insurancePremium" name="insurance-premium" id="insurance-premium">
                    </div>

                    <h2 class="mt-5">Quote Values</h2>

                    <div>
                        <label for="finance-rental-excluding-vat">Finance Rental Excluding Vat</label>
                        <input type="text" :value="financeRentalExcludingVat" name="finance-rental-excluding-vat" id="finance-rental-excluding-vat">
                    </div>
                    <div>
                        <label for="maintenance-rental-excluding-vat">Maintenance Rental Excluding Vat</label>
                        <input type="text" :value="maintenanceRentalExcludingVat" name="maintenance-rental-excluding-vat" id="maintenance-rental-excluding-vat">
                    </div>
                    <div>
                        <label for="co2-scale-charge">Co2 Scale Charge Percentage</label>
                        <input type="text" :value="co2ScaleChargePercentage" name="co2-scale-charge" id="co2-scale-charge">
                    </div>
                    <div>
                        <label for="contract-term">Contract Term</label>
                        <input type="text" :value="contractTerm" name="contract-term" id="contract-term">
                    </div>
                    <div>
                        <label for="p11d-value">P11d Value</label>
                        <input type="text" :value="p11dValue" name="p11d-value" id="p11d-value">
                    </div>

                </div>

                <div class="col-6">

                    <h2>Company Costs</h2>

                    <div>
                        <label for="finance-rentals">Finance Rentals</label>
                        <input type="text" :value="financeRentals" name="finance-rentals" id="finance-rentals">
                    </div>
                    <div>
                        <label for="maintenance-rentals">Maintenance Rentals</label>
                        <input type="text" :value="maintenanceRentals" name="maintenance-rentals" id="maintenance-rentals">
                    </div>
                    <div>
                        <label for="motor-insurance">Motor Insurance</label>
                        <input type="text" :value="insurancePremium" name="motor-insurance" id="motor-insurance">
                    </div>
                    <div>
                        <label for="provisions">Provisions</label>
                        <input type="text" :value="provisions" name="provisions" id="provisions">
                    </div>
                    <div>
                        <label for="eti">ETI</label>
                        <input type="text" :value="eti" name="eti" id="eti">
                    </div>
                    <div>
                        <label for="employers-ni">Employers NI</label>
                        <input type="text" :value="employersNi" name="employers-ni" id="employers-ni">
                    </div>
                    <div>
                        <label for="vat-recovery-on-rental">VAT Recovery On Rental</label>
                        <input type="text" :value="vatRecoveryOnRental" name="vat-recovery-on-rental" id="vat-recovery-on-rental">
                    </div>
                    <div>
                        <label for="vat-recovery-on-maintenance">VAT Recovery On Maintenance</label>
                        <input type="text" :value="vatRecoveryOnMaintenance" name="vat-recovery-on-maintenance" id="vat-recovery-on-maintenance">
                    </div>
                    <div>
                        <label for="total-company-costs">Total Company Costs</label>
                        <input type="text" :value="totalCompanyCosts" name="total-company-costs" id="total-company-costs">
                    </div>

                    <h2 class="mt-5">Salary Sacrifice Costs</h2>

                    <div>
                        <label for="nic-back-to-employee">NIC Back To Employee</label>
                        <input type="text" :value="nicBackToEmployee" name="nic-back-to-employee" id="nic-back-to-employee">
                    </div>
                    <div>
                        <label for="gross-monthly-sacrifice">Gross Monthly Sacrifice</label>
                        <input type="text" :value="grossMonthlySacrifice" name="gross-monthly-sacrifice" id="gross-monthly-sacrifice">
                    </div>
                    <div>
                        <label for="income-tax-saved-on-sacrifice">Income Tax Saved On Sacrifice</label>
                        <input type="text" :value="incomeTaxSavedOnSacrifice" name="income-tax-saved-on-sacrifice" id="income-tax-saved-on-sacrifice">
                    </div>
                    <div>
                        <label for="national-insurance-saved-on-sacrifice">National Insurance Saved On Sacrifice</label>
                        <input type="text" :value="nationalInsuranceSavedOnSacrifice" name="national-insurance-saved-on-sacrifice" id="national-insurance-saved-on-sacrifice">
                    </div>
                    <div>
                        <label for="benefit-in-kind-on-vehicle">Average Benefit in Kind</label>
                        <input type="text" :value="benefitInKindOnVehicle" name="benefit-in-kind-on-vehicle" id="benefit-in-kind-on-vehicle">
                    </div>
                    <div>
                        <label for="vehicle-net-monthly-cost">Illustrative Vehicle Monthly Net Cost</label>
                        <input type="text" :value="vehicleNetMonthlyCost" name="vehicle-net-monthly-cost" id="vehicle-net-monthly-cost">
                    </div>
                    <div>
                        <label for="employer-savings-cost-per-annum">Employer Savings Cost Per Annum</label>
                        <input type="text" :value="employerSavingsCostPerAnnum" name="employer-savings-cost-per-annum" id="employer-savings-cost-per-annum">
                    </div>
                </div>

            </div>
        </div>
    </div>

</template>

<script>
    import {EventBus} from "@/event-bus";

    export default {
        props: [
            'session',
            'adminPortalData',
            'adminPortalPrimaryProduct'
        ],

        beforeRouteEnter (to, from, next) {
            next(vm => {
                vm.vehicles = [];
                EventBus.$emit('fetchData', [
                  'driverprofile',
                  'profile',
                  'orders'
                ]);
                vm.type = vm.$route.meta.type;
            })
        },

        data: () => {
            return {
                // from lloyd latchford
                insurancePremium: 2500,

                // from quote
                financeRentalExcludingVat: 500,
                maintenanceRentalExcludingVat: 50,
                co2ScaleChargePercentage: 2,
                contractTerm: 36,
                p11dValue: 45000,
            }
        },

        methods: {
            round(value) {
                return Math.round((value + Number.EPSILON) * 100) / 100;
            }
        },

        computed: {

            // Scheme Level
            employerNationalInsuranceRate() {
                return parseFloat(this.adminPortalPrimaryProduct.product_calculation_employer_national_insurance_rate);
            },
            employeeNationalInsuranceRate20() {
                return parseFloat(this.adminPortalPrimaryProduct.product_calculation_employee_national_insurance_rate_20);
            },
            employeeNationalInsuranceRate40() {
                return parseFloat(this.adminPortalPrimaryProduct.product_calculation_employee_national_insurance_rate_40);
            },
            employeeNationalInsuranceRate45() {
                return parseFloat(this.adminPortalPrimaryProduct.product_calculation_employee_national_insurance_rate_45);
            },
            employeeNationalInsuranceRate60() {
                return parseFloat(this.adminPortalPrimaryProduct.product_calculation_employee_national_insurance_rate_60);
            },
            provisionPerMonth() {
                return parseFloat(this.adminPortalPrimaryProduct.product_calculation_provision_per_month);
            },
            vatRecoveryPercentage() {
                return parseFloat(this.adminPortalPrimaryProduct.product_calculation_vat_recovery);
            },
            etiIncluded() {
                return this.adminPortalPrimaryProduct.product_calculations_termination_product_included ? true : false;
            },
            etiPercentage24() {
                let etiPercentage24 = null;
                if (this.etiIncluded) {
                    if (this.adminPortalPrimaryProduct.product_calculations_termination_product == 1) {
                        etiPercentage24 = parseFloat(this.adminPortalPrimaryProduct.early_termination_reimbursement_option_1_24);
                    } else {
                        etiPercentage24 = parseFloat(this.adminPortalPrimaryProduct.early_termination_reimbursement_option_2_24);
                    }
                }
                return etiPercentage24;
            },
            etiPercentage36() {
                let etiPercentage36 = null;
                if (this.etiIncluded) {
                    if (this.adminPortalPrimaryProduct.product_calculations_termination_product == 1) {
                        etiPercentage36 = parseFloat(this.adminPortalPrimaryProduct.early_termination_reimbursement_option_1_36);
                    } else {
                        etiPercentage36 = parseFloat(this.adminPortalPrimaryProduct.early_termination_reimbursement_option_2_36);
                    }
                }
                return etiPercentage36;
            },
            etiPercentage48() {
                let etiPercentage48 = null;
                if (this.etiIncluded) {
                    if (this.adminPortalPrimaryProduct.product_calculations_termination_product == 1) {
                        etiPercentage48 = parseFloat(this.adminPortalPrimaryProduct.early_termination_reimbursement_option_1_48);
                    } else {
                        etiPercentage48 = parseFloat(this.adminPortalPrimaryProduct.early_termination_reimbursement_option_2_48);
                    }
                }
                return etiPercentage48;
            },
            giveNicSavingBackToEmployee() {
                return this.adminPortalPrimaryProduct.product_calculations_give_nic_saving_back_to_employee ? true : false;
            },
            percentageOfNICSharedWithEmployee() {
                return 50;
            },
            percentageForNicSavingCalculation() {
                return this.round((this.employerNationalInsuranceRate / (1 + this.employerNationalInsuranceRate / 100))
                    * (this.giveNicSavingBackToEmployee ? this.percentageOfNICSharedWithEmployee / 100 : 0));
            },
            percentageForEmployerSavingCalculation() {
                return this.giveNicSavingBackToEmployee ? this.employerNationalInsuranceRate : 0;
            },

            // Employee Level
            employeeTaxRate() {
                return this.session.driverProfile ? this.session.driverProfile.incomeTaxBand.ratePercent : false;
            },
            employeeNicRate() {
                return this.employeeTaxRate ? (this[`employeeNationalInsuranceRate${this.employeeTaxRate}`] / 100) : 0;
            },

            // early_termination_reimbursement_insurance_premium_tax where to use this?

            // Company Costs
            financeRentals() {
                return this.round(parseFloat(this.financeRentalExcludingVat) * 1.2 * 12);
            },
            maintenanceRentals() {
                return this.round(parseFloat(this.maintenanceRentalExcludingVat) * 1.2 * 12);
            },
            provisions() {
                return this.round(parseFloat(this.provisionPerMonth) * 12);
            },
            eti() {
                return this[`etiPercentage${this.contractTerm}`]
                    ? this.round(((((this.financeRentalExcludingVat + this.maintenanceRentalExcludingVat) * 12) * (this[`etiPercentage${this.contractTerm}`] / 100)) * 1.12))
                    : null;
            },
            employersNi() {
                return this.round(parseFloat(this.p11dValue) * (parseFloat(this.co2ScaleChargePercentage)/100) * (parseFloat(this.employerNationalInsuranceRate)/100));
            },
            vatRecoveryOnRental() {
                return this.round(parseFloat(this.financeRentalExcludingVat) * 0.5 * 0.2 * 12 * (parseFloat(this.vatRecoveryPercentage) / 100));
            },
            vatRecoveryOnMaintenance() {
                return this.round(parseFloat(this.maintenanceRentalExcludingVat) * 0.2 * 12 * (parseFloat(this.vatRecoveryPercentage) / 100));
            },
            totalCompanyCosts() {
                return this.round(this.financeRentals
                    + this.maintenanceRentals
                    + this.insurancePremium
                    + this.provisions
                    + this.eti
                    + this.employersNi
                    + this.vatRecoveryOnRental
                    + this.vatRecoveryOnMaintenance);
            },

            // Salary Sacrifice Cost
            nicBackToEmployee() {
                return this.round((this.percentageForNicSavingCalculation / 100) * this.totalCompanyCosts);
            },
            grossMonthlySacrifice() {
                return this.round((this.totalCompanyCosts - this.nicBackToEmployee) / 12);
            },
            incomeTaxSavedOnSacrifice() {
                return this.round((this.grossMonthlySacrifice * this.employeeTaxRate) / 100);
            },
            nationalInsuranceSavedOnSacrifice() {
                return this.round(this.grossMonthlySacrifice * this.employeeNicRate);
            },
            benefitInKindOnVehicle() {
                return this.round((this.p11dValue * (this.co2ScaleChargePercentage / 100) * (this.employeeTaxRate / 100)) / 12);
            },
            vehicleNetMonthlyCost() {
                return this.round(this.grossMonthlySacrifice - this.incomeTaxSavedOnSacrifice - this.nationalInsuranceSavedOnSacrifice + this.benefitInKindOnVehicle);
            },
            employerSavingsCostPerAnnum() {
                return this.round((this.grossMonthlySacrifice * this.percentageForEmployerSavingCalculation) / 100);
            },

        }
    }
</script>

<style scoped>
    .calculator-component label {
        width: 300px;
    }
</style>
